import { StyleFn } from '..'

export const FormControl: StyleFn = ({ color, font, size }) => ({
  root: {
    display: 'block',
    '&:not(:last-child)': {
      marginBottom: size.spacing[16],
    },
  },
  control: {
    width: '100%',
  },
  label: {
    display: 'flex',
    marginBottom: size.spacing[8],
    fontFamily: 'inherit',
    fontSize: font.size.small,
    fontWeight: font.weight.medium,
    lineHeight: font.lineheight.medium,
    color: color.getModalValues(color.text.secondary),
    '& > button': {
      marginLeft: size.spacing[4],
    },
  },
  optional: {
    lineHeight: font.lineheight.xsmall,
    marginTop: size.spacing[4],
    marginLeft: size.spacing[4],
    fontSize: font.size.xsmall,
    fontWeight: font.weight.regular,
    color: color.getModalValues(color.text.tertiary),
  },
  info: {
    flex: 1,
    textAlign: 'right',
  },
  help: {
    display: 'flex',
    marginTop: size.spacing[8],
    fontFamily: 'inherit',
    fontSize: font.size.xsmall,
    lineHeight: font.lineheight.xsmall,
    color: color.getModalValues(color.text.tertiary),
  },
  helplink: {
    flex: 1,
    textAlign: 'right',
    marginTop: `calc(-${size.spacing[4]})`,
  },
  _error: {
    '& $help': {
      color: color.type === 'light' ? color.feedback.error.default : color.palette.red[40],
    },
  },
  _success: {
    '& $help': {
      color: color.type === 'light' ? color.feedback.success.default : color.palette.green[40],
    },
  },
})
